<template>
  <div class="price">
    <div class="container">
      <div class="content">
        <img src="@/assets/price.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Product'
}
</script>

<style lang="scss" scoped>
.price {
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('~@/assets/bg_1.jpg') no-repeat top/cover;
  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    .content {
      padding: 20px;
      box-sizing: border-box;
      img {
        width: 100%;
      }
    }
  }
}
@media screen and (max-width: 1199px) {
  .container {
    width: 100%;
  }
}

@media screen and (min-width: 1200px) {
  .container {
    width: 1200px;
  }
}
</style>
